import { PROJECTS } from "../data/content";
import { Reveal } from "./Reveal";

export const Projects = () => {
  return (
    <section
      id="projects"
      data-testid="projects-section"
      className="relative py-24 lg:py-32 bg-[#F8FAFC]"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 mb-16 lg:mb-20">
          <Reveal>
            <div className="flex items-center gap-4 mb-6">
              <span className="h-px w-10 bg-[#0A192F]/40" />
              <span className="text-xs uppercase tracking-[0.3em] text-[#0A192F]/60">
                Featured Projects
              </span>
            </div>
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-[64px] leading-[1.02] tracking-tight text-[#0A192F]">
              Selected fieldwork.
            </h2>
          </Reveal>
          <Reveal delay={120} className="max-w-md">
            <p className="text-[#475569] leading-relaxed">
              A short selection of the deployments and partnerships defining the
              current chapter — spanning four continents and the full provider
              stack.
            </p>
          </Reveal>
        </div>

        <div className="grid md:grid-cols-2 gap-6 lg:gap-8">
          {PROJECTS.map((p, i) => (
            <Reveal
              key={p.title}
              delay={i * 110}
              className="group relative overflow-hidden border border-black/5 bg-white cursor-pointer"
            >
              <div
                className={`relative h-72 lg:h-80 bg-gradient-to-br ${p.color} overflow-hidden`}
              >
                <div className="absolute inset-0 grain" />
                <div className="absolute inset-0 flex items-end p-8">
                  <span className="font-serif text-7xl lg:text-8xl text-white/15">
                    0{i + 1}
                  </span>
                </div>
                <div className="absolute top-6 right-6 text-[10px] uppercase tracking-[0.3em] text-white/80">
                  {p.region}
                </div>
              </div>
              <div className="p-8 lg:p-10">
                <h3 className="font-serif text-2xl lg:text-3xl text-[#0A192F]">
                  {p.title}
                </h3>
                <div className="mt-4 flex items-center justify-between">
                  <span className="text-sm text-[#475569]">{p.impact}</span>
                  <span className="text-xs uppercase tracking-[0.3em] text-[#0A192F] group-hover:translate-x-1 transition-transform">
                    Case study →
                  </span>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
